import { FeathersModel } from './feathersModel'

export class Workgroup extends FeathersModel {
  static serviceName = 'workgroups'

  id: number
  name: string
  email: string
}
